import { PhoneIcon } from '@heroicons/react/20/solid';
import {
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  DevicePhoneMobileIcon,
  PhoneArrowUpRightIcon,
  CurrencyDollarIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';

// Get interaction category and icon
export const getInteractionCategory = type => {
  if (type?.includes('call')) {
    return { category: 'Llamada', icon: PhoneIcon, color: 'blue' };
  }
  if (type?.includes('whatsapp')) {
    return { category: 'WhatsApp', icon: DevicePhoneMobileIcon, color: 'green' };
  }
  if (type?.includes('email')) {
    return { category: 'Email', icon: EnvelopeIcon, color: 'indigo' };
  }
  if (type?.includes('sms')) {
    return { category: 'SMS', icon: PhoneArrowUpRightIcon, color: 'yellow' };
  }
  if (type?.includes('chat')) {
    return { category: 'Chat', icon: ChatBubbleLeftRightIcon, color: 'purple' };
  }
  if (type?.includes('payment')) {
    return { category: 'Pago', icon: CurrencyDollarIcon, color: 'emerald' };
  }
  if (type?.includes('url_payment')) {
    return { category: 'Enlace de pago', icon: LinkIcon, color: 'teal' };
  }
  return { category: 'Acción', icon: ChatBubbleLeftRightIcon, color: 'gray' };
};

